define('models/Provider',[
	'core/can',
	'models/Base',
	'models/Address'
], function(can, Base, Address) {
	
	// TODO Provider/List should return providers in access_token
	
	var Provider = Base.extend({
	
		findAll: 'GET /Provider/List',
		findOne: 'GET /Provider/{id}',
		create: 'POST /Provider',
		update: 'PUT /Provider',
		destroy: 'DELETE /Provider/{id}',
		
		findByAccountId: function(params, success, error) {
			return can.ajax({
					type: 'GET',
					url: can.sub('/Account/{id}/Providers', params)
				})
				.then(can.proxy(this.models, this))
				.then(success, error);
		}
	
	},{
		define: {
			Address: {
				Type: Address
			},
			Status: {
				// 1 - Review
				// 2 - Submitting Provider Authorization
				// 3 - Provider Authorization Sent
				// 4 - Ready to Bill
				// 5 - Issue
				value: 1
			}
		}
	});
	
	Provider.List = Provider.List.extend({
		comparator: 'Name',
		findByNPI: function(npi) {
			return this.filter(function(model) {
				return npi === model.attr('Npi');
			}).attr(0);
		},
		findByAccountId: function(accountid) {
			return this.filter(function(model) {
				return accountid === model.attr('AccountId');
			});
		}
	})
	
	Provider.prototype.rules = {
		Name: {
			validators: {
				notEmpty: {
					message: 'Name is required.'
				}
			}
		},
		Npi: {
			validators: {
				notEmpty: {
					message: 'NPI is required.'
				}
			}
		},
		Ptan: {
			validators: {
				notEmpty: {
					message: 'PTAN is required.'
				}
			}
		},
		/*TaxId: {
			validators: {
				notEmpty: {
					message: 'Federal Tax Number is required.'
				}
			}
		},
		ContactName: {
			validators: {
				notEmpty: {
					message: 'Name is required.'
				}
			}
		},
		ContactTitle: {
			validators: {
				notEmpty: {
					message: 'Title is required.'
				}
			}
		},
		Phone: {
			validators: {
				notEmpty: {
					message: 'Phone is required.'
				}
			}
		},
		Email: {
			validators: {
				notEmpty: {
					message: 'Email is required.'
				}
			}
		},*/
		'Address.Line1': {
			validators: {
				notEmpty: {
					message: 'Line 1 is required.'
				}
			}
		},
		// AddressLine2
		'Address.City': {
			validators: {
				notEmpty: {
					message: 'City is required.'
				}
			}
		},
		'Address.State': {
			validators: {
				notEmpty: {
					message: 'State is required.'
				}
			}
		},
		'Address.ZipCode': {
			validators: {
				notEmpty: {
					message: 'Zip is required.'
				}
			}
		}
	};
	
	return Provider;
	
});
